import IcLate from '@/assets/svg/ic-late.svg?inline'
import IcGainOn from '@/assets/svg/ic-gain-on.svg?inline'
import IcGainOff from '@/assets/svg/ic-gain-off.svg?inline'
import IcCloseBtn from '@/assets/svg/ic-close-btn.svg?inline'
import IcPause from '@/assets/svg/ic-pause.svg?inline'
import IcDelete from '@/assets/svg/ic-delete.svg?inline'
import IcArrowUp from '@/assets/svg/ic-arrow-up.svg?inline'
import { shiftStatuses } from '@/const'
import { getFormatDate, getShortId, getSecondsToTime } from '@/utils/format-strings'

export default {
  name: 'CourierDetailShift',
  props: {
    shift: {
      type: Object,
      required: true
    },
    isGain: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IcLate,
    IcGainOn,
    IcGainOff,
    IcCloseBtn,
    IcPause,
    IcDelete,
    IcArrowUp
  },
  static() {
    return {
      shiftStatuses
    }
  },
  methods: {
    getFormatDate,
    getShortId,
    getSecondsToTime,

    getLateOpening(shift) {
      if (shift.actual_time_from && shift.time_from) {
        return this.$moment(shift.actual_time_from).diff(this.$moment(shift.time_from)) > 0
      }
      return false
    },

    getDatetimeStatusUpdate(shift) {
      if (shift.datetime_status_update) {
        return `${this.$moment().diff(this.$moment(shift.datetime_status_update), 'minutes')} мин`
      }

      return ''
    },
    getStatusText(shift) {
      return `
        ${shift.status === 'gain' ? 'Между производствами' : this.shiftStatuses[shift.status].name}
        ${shift.datetime_status_update ? `: ${this.getDatetimeStatusUpdate(shift)}` : ''}
        `
    },
    getStatisticShowCondition(shift) {
      return !this.getDeleteCondition(shift)
    },

    getDeleteCondition(shift) {
      return (shift.isGainInfo && !shift.attended) || (!shift.isGainInfo && shift.status === 'not_open')
    },

    getNotActiveConditon(shift) {
      return shift.isGainInfo || (shift.status === 'close' || shift.status === 'not_open')
    },

    onDeleteShiftGain(shift) {
      if (shift.isGain) {
        this.$emit('delete-gain', shift.shift_id)
      } else {
        this.$emit('delete-shift', shift.shift_id)
      }
    }
  }
}